import {
  ComponentList,
  ComponentStore,
} from "@nxtlvlsoftware/alpine-typescript";
import Alpine from "alpinejs";

const _directives: { [key: string]: Alpine.DirectiveCallback } = {};
const _components: ComponentList = {};

export function directive(name: string, directive: Alpine.DirectiveCallback) {
  _directives[name] = directive;
}

export function directives(args: { [key: string]: Alpine.DirectiveCallback }) {
  for (const name in args) {
    directive(name, args[name]);
  }
}

export function component(name: string, component: any) {
  _components[name] = component;
}

export function components(args: { [key: string]: any }) {
  for (const name in args) {
    component(name, args[name]);
  }
}

export function init() {
  for (let key in _directives) {
    Alpine.directive(key, _directives[key]);
  }
  Alpine.plugin((a) => {
    console.assert(new ComponentStore(a, _components, true));
  });

  Alpine.start();
}
